import { Draggable } from "react-beautiful-dnd";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useParams } from "react-router-dom";

import { DeleteOutline, DragHandleOutlined } from "@mui/icons-material";
import { IconButton, ListItem, ListItemIcon, ListItemText } from "@mui/material";

import { getNmckBaseData } from "slices/nmck/nmckSelectors";
import { ribbonActions } from "slices/ribbon";

import styles from "./NmckList.module.css";

export const NmckListItem = ({ id, name, index, grouped, setDeleteDialogData }) => {
	const { nmckId: currentNmckId } = useParams();
	const dispatch = useDispatch();
	const baseData = useSelector(getNmckBaseData);
	const setClickedTableRow = (newValue) => dispatch(ribbonActions.setClickedTableRow(newValue));

	const clearClickedTableRow = () => {
		if (String(id) !== currentNmckId) {
			setClickedTableRow(null);
		}
	};

	return (
		<Draggable draggableId={String(id)} index={index}>
			{(provided) => (
				<ListItem
					disablePadding
					ref={provided.innerRef}
					title={name}
					component={NavLink}
					to={`/project/${baseData?.project_id}/nmck/${id}/`}
					className={styles.itemContainer}
					onClick={() => clearClickedTableRow()}
					sx={[
						({ palette }) => ({
							position: "relative",
							color: palette.text.primary,
							"&.active": {
								color: palette.primary.main,
							},
						}),
						grouped && { paddingLeft: "8px" },
					]}
					{...provided.draggableProps}
				>
					<ListItemIcon
						sx={{
							minWidth: "22px",
							cursor: "grab",
						}}
						{...provided.dragHandleProps}
					>
						<DragHandleOutlined color="disabled" sx={{ fontSize: "16px" }} />
					</ListItemIcon>
					<ListItemText
						primary={name}
						primaryTypographyProps={{
							noWrap: true,
							sx: { fontSize: "14px" },
						}}
						sx={{ margin: "0px 16px 0px 0px" }}
					/>
					<IconButton
						size="small"
						className={styles.deleteButton}
						onClick={(e) => {
							e.preventDefault();
							e.stopPropagation();
							setDeleteDialogData({ id, name });
						}}
					>
						<DeleteOutline sx={{ fontSize: "16px" }} />
					</IconButton>
				</ListItem>
			)}
		</Draggable>
	);
};
